import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { EMPTY_STRING, SCREEN_PATH } from "../../constants/global.constants";
import SignupForm from "../../views/agent-signup/SignupForm";
import { userActions } from "../../redux/actions/user.actions";

const SellWithUs = (props) => {
  const {
    user: { userId },getUserProfile,agentUser
  } = props;

  const navigate = useNavigate();

  const closeModal = () => {
    navigate(SCREEN_PATH.HOME, { replace: true });
  };

  useEffect(()=>{if(userId){
getUserProfile(userId)}
  },[userId])
  return (
   agentUser?.id && (<SignupForm
      show
      defaultValues={{
        agent:{
          firstName: agentUser?.name || EMPTY_STRING,
          lastName: agentUser?.lastName || EMPTY_STRING,
          email: agentUser?.email || EMPTY_STRING,
          password: '********' || EMPTY_STRING,
          confirmPassword: '********' || EMPTY_STRING
        }
      }}
      userId={userId}
      onClose={closeModal}
      closeModal={() => {}}
    />)
  );
};

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  agentUser: state.userReducer.user
});

const mapDispatchToProps = (dispatch) => ({getUserProfile: (id) => dispatch(userActions.getUserProfile(id)),});

export default connect(mapStateToProps, mapDispatchToProps)(SellWithUs);